export default __webpack_public_path__ + "static/media/integrityCenter.dc9af370.svg";